// extracted by mini-css-extract-plugin
export default {"mappingForm":"mappingForm---zvnAU","colWithTable":"colWithTable---oajm6","addFieldButton":"addFieldButton---N56u0"};